<div class="what-links-here-margin-main">
  <article class="specialcase-header" [innerHTML]="what_links_header"></article>
  <article class="mt-2 what-links-here-Info" [innerHTML]="what_links_body"></article>
  <div class="link-group" *ngIf="normalContentPresent">
    <div class="link-heading" [innerHTML]="links_to_fasb"></div>

    <div class="link-paragraph" *ngFor="let link of linkArrayNormal">
      <div>
        <span class="link-topic">{{link.source[0].targetTopicId}}<span *ngIf="link.source[0].targetSubtopicId != null">-</span>{{link.source[0].targetSubtopicId}}<span *ngIf="link.source[0].targetSectionId != null">-</span>{{link.source[0].targetSectionId}}<span *ngIf="link.source[0].targetParagraphId != null">-{{link.source[0].targetParagraphId.split("-")[1]}}</span></span>
      </div>
      <div class="link-body">
        <div *ngFor="let source of link.source">
          <span *ngIf="!source.isGlossary">
            <span class="link mt-1rem display-list" (click)="gotoContent(source)" (keyup.enter)="gotoContent(source)" tabindex="0">{{source.sourceTopicId}}&nbsp;{{source.sourceTopicTitle}}&nbsp;>&nbsp;{{source.sourceSubtopicId}}&nbsp;{{source.sourceSubtopicTitle}}&nbsp;>&nbsp;{{source.sourceSectionId}}&nbsp;{{source.sourceSectionTitle}}&nbsp;>&nbsp;<span *ngIf="source.sourceSubsectionTitle != null">{{source.sourceSubsectionTitle}}, paragraph </span><span *ngIf="link.source[0].sourceParagraphId != null">{{source.sourceParagraphId}}</span></span>
          </span>
          <span *ngIf="source.isGlossary">
            <span class="link mt-1rem display-list" (click)="gotoGlossary(source)" (keyup.enter)="gotoGlossary(source)" tabindex="0">Master Glossary&nbsp;>&nbsp;{{source.glossaryName}}</span>
          </span>
        </div>

      </div>
    </div>

    <div class="link-heading mt-2 font-16" *ngIf="linkArrayNormal.length==0">
      {{no_links_available}}
    </div>
  </div>

  <div class="link-group" *ngIf="secContentPresent">
    <div class="link-heading" [innerHTML]="links_to_sec"></div>

    <div class="link-paragraph" *ngFor="let link of linkArraySec">
      <div>
        <span class="link-topic">{{link.source[0].targetTopicId}}<span *ngIf="link.source[0].targetSubtopicId != null">-</span>{{link.source[0].targetSubtopicId}}<span *ngIf="link.source[0].targetSectionId != null">-</span>{{link.source[0].targetSectionId}}<span *ngIf="link.source[0].targetParagraphId != null">-{{link.source[0].targetParagraphId.split("-")[1]}}</span></span>
      </div>
      <div class="link-body">
        <div *ngFor="let source of link.source">
          <span *ngIf="!source.isGlossary">
            <span class="link mt-1rem display-list" (click)="gotoContent(source)" (keyup.enter)="gotoContent(source)" tabindex="0">{{source.sourceTopicId}}&nbsp;{{source.sourceTopicTitle}}&nbsp;>&nbsp;{{source.sourceSubtopicId}}&nbsp;{{source.sourceSubtopicTitle}}&nbsp;>&nbsp;{{source.sourceSectionId}}&nbsp;{{source.sourceSectionTitle}}&nbsp;>&nbsp;<span *ngIf="source.sourceSubsectionTitle != null">{{source.sourceSubsectionTitle}}, paragraph </span> <span *ngIf="source.sourceParagraphId != null">{{source.sourceParagraphId}}</span></span>
          </span>
          <span *ngIf="source.isGlossary">
            <span class="link mt-1rem display-list" (click)="gotoGlossary(source)" (keyup.enter)="gotoGlossary(source)" tabindex="0">Master Glossary&nbsp;>&nbsp;{{source.glossaryName}}</span>
          </span>
        </div>

      </div>
    </div>

    <div class="link-heading mt-2 font-16" *ngIf="linkArraySec.length==0">
      {{no_links_available}}
    </div>
  </div>
</div>
